import { Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { t } from 'src/lib/language';
import ActionButton from 'src/components/UI/ActionButton';

const AddCustomfieldButton = (props: ButtonProps) => {
  const { disabled } = props;
  const lang = useSelector((state: Store) => state.language.language);
  const dispatch = useAppDispatch();

  const handleOpen = () => {
    dispatch(openModal({ modal: MODALS.addCustomfields }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.add_customfield')}
      placement="top-start">
      <>
        <ActionButton
          variant="outlined"
          onClick={handleOpen}
          disabled={disabled}
          style={{ marginRight: 4 }}>
          <AddIcon />
        </ActionButton>
      </>
    </Tooltip>
  );
};

export default AddCustomfieldButton;
